// src/components/IdleTimerContainer.js
import React, { useContext, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { AuthContext } from '../contexts/AuthContext';
import { auth } from '../utils/firebaseConfig';
import { toast } from 'react-toastify';

const IdleTimerContainer = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const [isPrompted, setIsPrompted] = useState(false);

  const onPrompt = () => {
    setIsPrompted(true);
  };

  const onIdle = () => {
    if (currentUser) {
      auth.signOut();
      toast.info('You have been signed out due to inactivity.');
    }
  };

  const onActive = () => {
    if (isPrompted) {
      setIsPrompted(false);
      toast.dismiss();
    }
  };

  useIdleTimer({
    timeout: 20 * 60 * 1000, // 20 minutes
    promptBeforeIdle: 1 * 60 * 1000, // 1 minute before idle
    onPrompt,
    onIdle,
    onActive,
    debounce: 500,
    crossTab: true,
  });

  return (
    <>
      {isPrompted && (
        <div className="idle-modal">
          <p>You will be logged out soon due to inactivity.</p>
        </div>
      )}
      {children}
    </>
  );
};

export default IdleTimerContainer;
